import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { EMPTY_CONTACT, validateContact, contactErrorMessage } from "../lib/contact";

const notifyError = (message) => toast.error(<span data-testid="contact-error-message">{message}</span>, { id: "contact-status" });

export const useContactForm = () => {
  const [form, setForm] = useState({ ...EMPTY_CONTACT });
  const [loading, setLoading] = useState(false);
  const submitting = useRef(false);
  const update = (key) => (event) => {
    const value = event.target.value;
    setForm((current) => ({ ...current, [key]: value }));
  };

  const submit = async (event) => {
    event.preventDefault();
    if (submitting.current) return;
    const error = validateContact(form);
    if (error) return notifyError(error);
    submitting.current = true;
    setLoading(true);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, form);
      if (data.status !== "success") throw new Error("Unexpected contact response");
      toast.success(<span data-testid="contact-success-message">¡Mensaje enviado! Te responderemos muy pronto.</span>, { id: "contact-status" });
      setForm({ ...EMPTY_CONTACT });
    } catch (error) {
      notifyError(contactErrorMessage(error));
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };
  return { form, loading, update, submit };
};